<template>
  <span>
    <notifications position="top center" ></notifications>



    <a  @click="isOpen = !isOpen" href="#"  class="text-pink">
      <span class="lg:pl-2 inline-flex items-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 lg:h-6 lg:w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
        </svg>
      </span>
    </a>

      <transition
          enter-class="transition ease-out duration-100 transform"
          enter-active-class="opacity-0"
          enter-to-class="opacity-100"
          leave-class="transition ease-in duration-200 transform"
          leave-active-class="opacity-100"
          leave-to-class="opacity-0"
      >
      <div  v-if="isOpen"  class="fixed z-10 inset-0 overflow-y-auto">
        <div class="flex items-start justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
          <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle xl:max-w-lg w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <div class="sm:flex sm:items-start">
            <div class="text-center sm:mt-0 sm:text-left w-full">
              <div class="flex justify-between items-center pb-3">
                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
                  Update Event
                </h3>
                <div class="modal-close cursor-pointer z-50">
                  <svg @click="isOpen = false" class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path></svg>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Title</label>
                  <div class="mt-1">
                    <input type="text" v-model="form.title" id="quantity" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300" >
                  </div>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Event Type</label>
                  <div class="mt-1">
                    <select id="day_selection"  v-model="day_selection"  autocomplete="" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300">
                      <option value="single">Single Day</option>
                      <option value="multiple">Multiple Day</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Start Date</label>
                  <div class="mt-1">
                   <flat-pickr v-model="form.begins_at" :config="dateTimeConfig" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300"></flat-pickr>
                  </div>
                </div>
              </div>

              <div class="my-3" v-if="day_selection == `multiple`">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">End Date</label>
                  <div class="mt-1">
                    <flat-pickr v-model="form.end_date" :config="dateTimeConfig" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300"></flat-pickr>
                  </div>
                </div>
              </div>

              <div class="my-3">
                <div>
                  <label for="quantity" class="block text-sm font-medium text-gray-700">Address</label>
                  <div class="mt-1">
<!--                    <flat-pickr v-model="form.date_received" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300"></flat-pickr>-->
<!--                    <vue-google-autocomplete-->
<!--                        :value="form.fullAddress"-->
<!--                        id="startLocationField"-->
<!--                        classname="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300"-->
<!--                        placeholder="Enter address"-->
<!--                        v-on:placechanged="getAddressData"-->
<!--                        v-on:keypress="resetAddressOnKeyPress"-->
<!--                        country="us"-->
<!--                    />-->
                     <GMapAutocomplete
                         :value="form.fullAddress"
                         placeholder="Type to search for address"
                         @place_changed="getAddressData"
                         :class="`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full  border-gray-300 h-10`"
                     >
                    </GMapAutocomplete>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button @click="createOrUpdate" type="button" class="w-full inline-flex justify-center border border-transparent shadow-sm px-4 py-2 bg-pink-500 text-base font-medium text-white hover:bg-pink-700 focus:outline-none  focus:ring-offset-2 focus:ring-pink-500 sm:ml-3 sm:w-auto sm:text-sm">
              Update
            </button>
            <button @click="isOpen = false" type="button" class="mt-3 w-full inline-flex justify-center border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none  focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm">
              Cancel
            </button>
          </div>
        </div>
      </div>
      </div>

    </transition>
  </span>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';

export default {
  name: 'EditCampaignEventLink',
  props: {
    campaignId: null,
    campaignEventId: null,
    campaignName: null,
    campaignEvent: null,
  },
  data() {
    return {
      dateTimeConfig: {
        enableTime: true,
        dateFormat: "Y-m-d h:i K",
        time_24hr: false,
      },
      day_selection: 'single',
      isOpen: false,
      form: {
        title: null,
        address: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        description: null,
        begins_at: null,
        end_date: null,
        campaign_id: this.campaignId,
        id: this.campaignEventId,
        fullAddress: null,
      }
    }
  },
  components: {
    flatPickr,
  },
  created() {
    if (this.campaignEventId){
      axios.get('/campaign-event/' + this.campaignEventId)
          .then(response => {
            // console.log(response.data)
            this.form = response.data
            if (this.form.end_date){
              this.day_selection = 'multiple'
            }
          })

      this.form.is_new = false
    }
  },
  methods: {
    setOpenToFalse() {
      this.isOpen = false;
    },
    createOrUpdate() {
      if (!this.form.begins_at){
        this.$notify({
          text: 'Start date is required',
          type: 'error',
        })
        return
      }
      if (!this.form.address){
        this.$notify({
          text: 'Address is required',
          type: 'error',
        })
        return
      }
      if (!this.form.title){
        this.$notify({
          text: 'Title is required',
          type: 'error',
        })
        return
      }
      axios.post('/campaign-event/create', this.form)
          .then(response => {
            // console.log(response.data)
            this.$notify({
              text: 'Campaign event successfully ' + this.action(),
              type: 'success',
            })

            window.location.href = '/campaign/'+this.campaignId+'/event'
          })
    },
    action() {
      return this.campaignEventId ? 'updated' : 'created'
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.form.address = addressData.formatted_address
      // this.form.address = addressData.street_number + ' ' + addressData.route
      // this.form.city = addressData.locality
      // this.form.state = addressData.administrative_area_level_1
      // this.form.zip = addressData.postal_code
    },

    resetAddressOnKeyPress: function (changes) {
      //console.log(changes)
    },
    eventsUrl() {
      return '/campaign/'+this.campaignId+'/event/'
    }
  }
}
</script>

